const MainPage = () => import('@/pages/MainPage')
const Login = () => import('@/pages/Login')
const NotFound = () => import('@/pages/NotFound')
const SubsysPage = () => import('@/pages/SubsysPage')
const BlankPage = () => import('@/pages/BlankPage')
//
const viewRspProjUser = () => import('@/pages/proj/projuser/viewRspProjUser')
const editRspProjUser = () => import('@/pages/proj/projuser/editRspProjUser')
const addRspCtrAcct = () => import('@/pages/proj/ctracct/addRspCtrAcct')
const editRspCtrAcct = () => import('@/pages/proj/ctracct/editRspCtrAcct')
const viewRspCtrAcct = () => import('@/pages/proj/ctracct/viewRspCtrAcct')
const addRspProject = () => import('@/pages/proj/project/addRspProject')
const editRspProject = () => import('@/pages/proj/project/editRspProject')
const viewRspProject = () => import('@/pages/proj/project/viewRspProject')
const confProjCtrAcct = () => import('@/pages/proj/project/confProjCtrAcct')
const confProjSettleEntity = () => import('@/pages/proj/project/confProjSettleEntity')
const confProjSettlePayment = () => import('@/pages/proj/project/confProjSettlePayment')
const confProjSettleProjMgr = () => import('@/pages/proj/project/confProjSettleProjMgr')
const confProjIncomeEntity = () => import('@/pages/proj/project/confProjIncomeEntity')
const confProjAcctPayEntity = () => import('@/pages/proj/project/confProjAcctPayEntity')
const confProjAcctReceiveEntity = () => import('@/pages/proj/project/confProjAcctReceiveEntity')
const confProjAcctCurEntity = () => import('@/pages/proj/project/confProjAcctCurEntity')
//
const entryStatistic = () => import('@/pages/proj/project/entryStatistic')
const entryOpStat = () => import('@/pages/proj/project/entryOpStat')
const entryFundStat = () => import('@/pages/proj/project/entryFundStat')
const entryAccountantFlowTransList = () => import('@/pages/proj/project/entryAccountantFlowTransList')
const entryCashierFlowTransList = () => import('@/pages/proj/project/entryCashierFlowTransList')
const entrySettleTransList = () => import('@/pages/proj/project/entrySettleTransList')
const entryIncomeTransList = () => import('@/pages/proj/project/entryIncomeTransList')
const entryAcctPayTransList = () => import('@/pages/proj/project/entryAcctPayTransList')
const entryAcctReceiveTransList = () => import('@/pages/proj/project/entryAcctReceiveTransList')
const entryAcctCurTransList = () => import('@/pages/proj/project/entryAcctCurTransList')
const entryProjectDownload = () => import('@/pages/proj/project/entryProjectDownload')
const entryIncomeStatement = () => import('@/pages/proj/project/entryIncomeStatement')
const entryAssetDebt = () => import('@/pages/proj/project/entryAssetDebt')
//
const entrySettleInvoiceList = () => import('@/pages/proj/project/entrySettleInvoiceList')
const entryAccountantTransList = () => import('@/pages/proj/project/entryAccountantTransList')
const entryProjMthRptList = () => import('@/pages/proj/rpt/entryProjMthRptList')
const entryProjMthRptDetail = () => import('@/pages/proj/rpt/entryProjMthRptDetail')
//
const compIncomeStatement = () => import('@/pages/proj/comprpt/compIncomeStatement')
const compAssetDebt = () => import('@/pages/proj/comprpt/compAssetDebt')
const compAcctReceive = () => import('@/pages/proj/comprpt/compAcctReceive')
const compAcctPay = () => import('@/pages/proj/comprpt/compAcctPay')
//
export const routerCommon = {
  path: '/',
  component: MainPage,
  children: [
    {
      name: 'subsys_page',
      path: '/subsys_page',
      component: SubsysPage,
      props: {
      }
    },
    {
      name: 'blank_page',
      path: '/blank_page',
      component: BlankPage,
      props: {
      }
    },
    //
    {
      path: '/proj/projuser/viewRspProjUser',
      component: viewRspProjUser,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M678Q7'
      }
    },
    {
      path: '/proj/projuser/editRspProjUser',
      component: editRspProjUser,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M678Q7'
      }
    },
    {
      path: '/proj/ctracct/addRspCtrAcct',
      component: addRspCtrAcct,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'MTUJDI'
      }
    },
    {
      path: '/proj/ctracct/editRspCtrAcct',
      component: editRspCtrAcct,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'MTUJDI'
      }
    },
    {
      path: '/proj/ctracct/viewRspCtrAcct',
      component: viewRspCtrAcct,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'MTUJDI'
      }
    },
    {
      path: '/proj/project/addRspProject',
      component: addRspProject,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/editRspProject',
      component: editRspProject,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/viewRspProject',
      component: viewRspProject,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/confProjCtrAcct',
      component: confProjCtrAcct,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/confProjSettleEntity',
      component: confProjSettleEntity,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/confProjSettlePayment',
      component: confProjSettlePayment,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/confProjSettleProjMgr',
      component: confProjSettleProjMgr,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/confProjIncomeEntity',
      component: confProjIncomeEntity,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/confProjAcctPayEntity',
      component: confProjAcctPayEntity,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/confProjAcctReceiveEntity',
      component: confProjAcctReceiveEntity,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/confProjAcctCurEntity',
      component: confProjAcctCurEntity,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'CONF',
        moduleCode: 'M35KUP'
      }
    },
    //
    {
      path: '/proj/project/entryStatistic',
      component: entryStatistic,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryOpStat',
      component: entryOpStat,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryFundStat',
      component: entryFundStat,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryAccountantFlowTransList',
      component: entryAccountantFlowTransList,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryCashierFlowTransList',
      component: entryCashierFlowTransList,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entrySettleTransList',
      component: entrySettleTransList,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryIncomeTransList',
      component: entryIncomeTransList,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryAcctPayTransList',
      component: entryAcctPayTransList,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryAcctReceiveTransList',
      component: entryAcctReceiveTransList,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryAcctCurTransList',
      component: entryAcctCurTransList,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryProjectDownload',
      component: entryProjectDownload,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryIncomeStatement',
      component: entryIncomeStatement,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryAssetDebt',
      component: entryAssetDebt,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    //
    {
      path: '/proj/project/entrySettleInvoiceList',
      component: entrySettleInvoiceList,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/project/entryAccountantTransList',
      component: entryAccountantTransList,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/rpt/entryProjMthRptList',
      component: entryProjMthRptList,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/rpt/entryProjMthRptDetail',
      component: entryProjMthRptDetail,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M35KUP'
      }
    },
    {
      path: '/proj/comprpt/compIncomeStatement',
      component: compIncomeStatement,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M9WTQC'
      }
    },
    {
      path: '/proj/comprpt/compAssetDebt',
      component: compAssetDebt,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'MZI7SJ'
      }
    },
    {
      path: '/proj/comprpt/compAcctReceive',
      component: compAcctReceive,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'MVEWVQ'
      }
    },
    {
      path: '/proj/comprpt/compAcctPay',
      component: compAcctPay,
      props: {
        subsysKey: 'PROJ',
        moduleType: 'DATA',
        moduleCode: 'M87SVY'
      }
    }
  ]
}

export const routers = [
  {
    path: '/login',
    name: '登录',
    component: Login,
    props: {
      moduleCode: 'MZIIUA'
    }
  },
  {
    path: '/profile/changePwdByMobile',
    name: '忘记密码',
    component: () => import('@/pages/profile/changePwdByMobile'),
    // component: () => import('@/pages/Login'),
    props: {
      // moduleCode: 'xxxxxxx'
    }
  },
  {
    path: '*',
    component: NotFound
  }
]



// WEBPACK FOOTER //
// ./src/router/router.js